import { useTheme } from 'styled-components';

import * as Icons from '@common/components/Icons';

import {
  Container,
  CustomButton,
  CustomButtons,
  FloatingContainer,
} from './LayoutSwitcher.styled';

export function LayoutSwitcher() {
  const theme = useTheme();
  const activeFill = theme.colors.bluegrey[15];
  const inActiveFill = theme.colors.bluegrey[70];

  return (
    <Container>
      <FloatingContainer>
        <CustomButtons>
          <CustomButton
            onClick={() => {
              theme.setLayoutPreference('grid');
            }}
          >
            <Icons.GridLayout
              fill={
                theme.layoutPreference === 'grid' ? activeFill : inActiveFill
              }
            />
          </CustomButton>
          <CustomButton
            onClick={() => {
              theme.setLayoutPreference('column');
            }}
          >
            <Icons.LayoutColumn
              fill={
                theme.layoutPreference === 'column' ? activeFill : inActiveFill
              }
            />
          </CustomButton>
        </CustomButtons>
      </FloatingContainer>
    </Container>
  );
}

export default LayoutSwitcher;
